import React, { ComponentProps } from 'react';
import { TableBody as CarbonTableBody } from '@carbon/react';

export type TableBodyProps = ComponentProps<typeof CarbonTableBody>;

export const TableBody = (props: TableBodyProps) => (
  <CarbonTableBody {...props} />
);

TableBody.displayName = 'TableBody';
